export const jsDataUrl = process.env.jsDataUrl;
export const jsStaticUrl = process.env.jsStaticUrl;
export const jsBlogDataUrl = process.env.jsBlogDataUrl;
export const jsSceneDataUrl = process.env.jsSceneDataUrl;
export const jsUrl = process.env.jsUrl;
export const isLocal = process.env.DEPLOY_ENV === "local";
export const CONFIG_API = process.env.CONFIG_API;
export const keywords = ["AI web designer", "AI web developer", "AI Web Designer & Developer", "Wegic", "website development", "ideal website", "web design assistants", "web development assistants", "chat with Wegic", "web design AI", "web development AI"];